<template>
    <transition name="modal">
        <!-- The Modal -->
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-dialog modal-dialog-scrollable">
                    <div class="modal-content rounded-8">

                        <!-- Modal Header -->
                        <div class="modal-header bg-utel-v2-secondary text-primary">
                            <h5 class="modal-title" id="infoModalLabel">Información del curso</h5>
                            <button type="button" class="btn btn-default" @click.prevent="close" data-dismiss="modal">X</button>
                        </div>

                        <!-- Modal body -->
                        <div class="modal-body text-center">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="center-img-vertical">
                                        <small>{{ getCategories(watchCourse.categories) }}</small>
                                        <img :src="watchCourse.image" alt="">
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 p-4">
                                    <h3>{{ watchCourse.name }}</h3>
                                    <ul class="nav nav-pills mb-3 col-12 rounded bg-white ff-sora px-0 py-3" id="ext-1" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link active" id="pills-ext-tab" data-bs-toggle="pill" data-bs-target="#ext-11-tab-content"
                                                type="button" role="tab" aria-controls="ext-11-tab-content" aria-selected="true"><strong>Descripción</strong></button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="pills-ext2-tab" data-bs-toggle="pill" data-bs-target="#ext-22-tab-content"
                                                type="button" role="tab" aria-controls="ext-22-tab-content" aria-selected="false"><strong>Visión general</strong></button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="pills-ext3-tab" data-bs-toggle="pill" data-bs-target="#ext-33-tab-content"
                                                type="button" role="tab" aria-controls="ext-33-tab-content" aria-selected="false"><strong>Temario</strong></button>
                                        </li>
                                    </ul>
                                    <div class="tab-content" id="pills-exts-tabContent">
                                        <div class="tab-pane fade show active" id="ext-11-tab-content" role="tabpanel" aria-labelledby="pills-ext-tab">
                                            <p>{{ strippedContent(watchCourse.content) }}</p>
                                        </div>
                                        <div class="tab-pane fade" id="ext-22-tab-content" role="tabpanel" aria-labelledby="pills-ext2-tab">
                                            <table class="table">
                                                <tbody>
                                                    <tr>
                                                        <td class="text-start"><i class="fa fa-file"></i> Lecciones</td>
                                                        <td class="text-end">{{ getLecciones(watchCourse.sections) }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-start"><i class="fa fa-puzzle-piece"></i> Cuestionarios</td>
                                                        <td class="text-end">{{ getCuestionarios(watchCourse.sections) }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-start"><i class="fa fa-clock"></i> Duración</td>
                                                        <td class="text-end">{{ watchCourse.duration }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-start"><i class="fa fa-users"></i> Estudiantes</td>
                                                        <td class="text-end">{{ watchCourse.count_students }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-start"><i class="fa fa-check-square"></i> Evaluaciones</td>
                                                        <td class="text-end">{{ (getCuestionarios(watchCourse.sections) > 0 ? 'Si' : 'No') }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="tab-pane fade" id="ext-33-tab-content" role="tabpanel" aria-labelledby="pills-ext3-tab">
                                            <table class="table">
                                                <tbody>
                                                    <tr v-for="item in getTemario(watchCourse.sections)">
                                                        <td class="text-primary text-start" :colspan="item.tipo == 'seccion' ? '3' : '1'" v-if="item.tipo == 'seccion'"><strong>{{ item.titulo }}</strong></td>
                                                        <td v-if="item.tipo != 'seccion'"><i :class="'fa fa-'+(item.tipo == 'lp_lesson' ? 'file' : 'puzzle-piece')"> </i>{{ item.indice }}</td>
                                                        <td v-if="item.tipo != 'seccion'">{{ item.titulo }}</td>
                                                        <td v-if="item.tipo != 'seccion'">{{ item.duracion }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <!--<button type="button" class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8" data-bs-dismiss="modal"
                                @click.prevent="agregarCursoDesdeModal(watchCourse)">
                                Agregar curso a ruta
                            </button>-->
                            <button type="button" class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8" data-bs-dismiss="modal" @click.prevent="close">
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['course'],
    data() {
        return {
            watchCourse:{id:'', content: '', name: '', duration: '', sections: [], categories:[], count_students: 0}
        }
    },
    mounted() {
        console.log(this.course);
        this.watchCourse = this.course;
    },
    methods: {
        agregarCursoDesdeModal(item){
            //this.addCourseItems( item.image, item.name, item.id, item.slug, item );
            this.$emit("setCourse", item);
        },
        close(){
            this.$emit("close");
        },
        strippedContent(text) {
            let regex = /(<([^>]+)>|&nbsp;)/ig;
            return text.replace(regex, "");
        },
        getLecciones(sections){
            let cantidadLecciones = 0;
            sections.forEach((section)=>{
                section.items.forEach((item)=>{
                    if(item.type == 'lp_lesson'){
                        cantidadLecciones++;
                    }
                });
            });
            return cantidadLecciones;
        },
        getCuestionarios(sections){
            let cantidadQuizes = 0;
            sections.forEach((section)=>{
                section.items.forEach((item)=>{
                    if(item.type == 'lp_quiz'){
                        cantidadQuizes++;
                    }
                });
            });
            return cantidadQuizes;
        },
        getTemario(sections){
            let registros = [];
            let index = 1;
            sections.forEach((section)=>{
                registros.push({
                    titulo: section.title, duracion: '', indice : index+'.', tipo: 'seccion'
                });
                let index2 = 1;
                section.items.forEach((item)=>{
                    let titulo_leccion = item.type == 'lp_lesson' ? 'Lección ' : 'Quiz ';
                    registros.push({
                        titulo: item.title, duracion: item.duration, indice : titulo_leccion+index+'.'+index2+'.', tipo : item.type
                    });
                    index2++;
                });
                index++;
            });
            return registros;
        },
        getCategories(categories){
            let catArray = [];
            categories.forEach((cat)=>{
                catArray.push(cat.name);
            });
            return catArray.join(", ");
        }
    }
}
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  /*display: table;*/
  transition: opacity .3s ease;
}

.modal-wrapper {
  /*display: table-cell;*/
  vertical-align: middle;
}

.modal-dialog-scrollable .modal-body {
    max-height: 78vh;
}

.modal-dialog.modal-dialog-scrollable{
    max-width: 900px;
}

@media (min-width: 960px){
    .center-img-vertical{
        position: relative;
        top: 15%;
    }
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link{
    background-color: #4000BC;
}
</style>
